import React, { ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';

interface IProps {
  children: ReactNode;
  isActive: boolean;
  handleClick?: () => void;
}

const ImageDisplayBorder = ({
  children,
  isActive,
  handleClick = undefined,
}: IProps) => (
  <button
    aria-label="image-display-border"
    className={twMerge(
      isActive ? 'border-green-50 shadow' : 'border-gray-20 opacity-75',
      'hover:border-green-50 hover:opacity-100 hover:shadow',
      'cursor-pointer border-2 bg-gray-10 p-1',
      'flex min-h-[176px] w-full justify-between'
    )}
    type="button"
    onClick={handleClick}
  >
    {children}
  </button>
);

export default ImageDisplayBorder;
